<template>
  <t-dialog
    class="application-add"
    :visible="visible"
    :closeOnOverlayClick="false"
    :footer="true"
    :confirmBtn="{ content: '确认', loading: loadingOper }"
    @close="onClose"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div slot="header">编辑用户</div>
    <div slot="body">
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit" :colon="true">
        <t-form-item label="用户名称">
          <div>{{ userInfo.entityName }}</div>
        </t-form-item>
        <t-form-item label="手机号">
          <div>{{ userInfo.phoneNumber }}</div>
        </t-form-item>
        <t-form-item label="所属应用" name="appId">
          <t-select v-model="formData.appId">
            <t-option v-for="item in appList" :key="item.value" :label="item.label" :value="item.value"></t-option>
          </t-select>
        </t-form-item>
        <t-form-item label="应用角色" name="roleType">
          <t-select v-model="formData.roleType">
            <t-option label="管理员" value="admin"></t-option>
            <t-option label="用户" value="user"></t-option>
          </t-select>
        </t-form-item>
      </t-form>
    </div>
  </t-dialog>
</template>

<script>
import { modifyAppUser } from '@/api/application/app';

export default {
  name: 'user-edit',
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
    },
    appList: {
      type: Array,
      required: true,
    },
    userInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: true,
      formData: {
        appId: '',
        roleType: '',
      },
      rules: {
        appId: [{ required: true, message: '请选择应用', type: 'error' }],
        roleType: [{ required: true, message: '请选择应用角色', type: 'error' }],
      },

      loadingOper: false,
    };
  },
  created() {
    this.formData.appId = this.userInfo.appId;
    this.formData.roleType = this.userInfo.roleType;
  },
  methods: {
    onClose() {
      this.$emit('update:dialogVisible', false);
    },
    onCancel() {
      //
    },
    async onConfirm() {
      const validRet = await this.$refs.form.validate();
      console.log('validRet', validRet);
      if (validRet !== true) {
        console.error('表单有误');
        return;
      }
      try {
        this.loadingOper = true;
        const data = {
          id: this.userInfo.id,
          entityId: this.userInfo.entityId,
          entityName: this.userInfo.entityName,
          phoneNumber: this.userInfo.phoneNumber,
          roleType: this.formData.roleType,
          appId: this.formData.appId,
        };

        await modifyAppUser({
          data,
        });

        this.$message.success('操作成功');
        this.$emit('update:dialogVisible', false);
        this.$emit('onRefresh');
      } finally {
        this.loadingOper = false;
      }
    },
    onReset() {
      //
    },
    onSubmit() {
      //
    },
  },
};
</script>

<style lang="less" scoped>
.application-add {
  /deep/ .t-dialog__footer {
    text-align: center;
  }
}
</style>
